import {PhoneNumber} from './PhoneNumber';

export type SelfEmployedInformation = {
  titleBefore: string | null;
  firstName: string;
  lastName: string;
  titleAfter: string | null;
  phoneNumber: PhoneNumber | null;
  emailAddress: string | null;
};
